import { toJS } from "mobx";
import UsersStore from "../stores/internal/UsersStore";

export const getAllUsers = () => toJS(UsersStore.users);
export const getUserByLoginId = (user_login_id) => toJS(UsersStore.usersByLoginId[user_login_id])
